import { render, staticRenderFns } from "./IndexAlt.vue?vue&type=template&id=ba74842a"
import script from "./IndexAlt.vue?vue&type=script&lang=js"
export * from "./IndexAlt.vue?vue&type=script&lang=js"
import style0 from "./IndexAlt.vue?vue&type=style&index=0&id=ba74842a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports